import React, { Component } from 'react';
import { Select } from 'antd';
import SymbolText from './SymbolText'
import Field from './Field';

const { Option } = Select;

class InvestigationMedicineType extends Component {
    handleChange = (value, key) => {
        const { data, index, onChange } = this.props;
        switch(key) {
            case 'responsibleFieldId':
                const { symbol, id } = data;
                onChange({
                    id,
                    symbol,
                    responsibleFieldId: value,
                }, index);
                return;
            default:
                data[key] = value;
                break;
        }
        onChange(data, index);
    }

    render() {
        const { data, fieldList, medicineTypeList } = this.props;
        const { symbol, responsibleFieldId, investigationMedicineType } = data;
        const medicineTypeOption = medicineTypeList.map(d => <Option key={d.researchProductTypeId} title={d.researchProductTypeName}>{d.researchProductTypeName}</Option>);
        return (
            <div>
                <SymbolText symbol={symbol} />
                <div className="border">
                    <Field value={responsibleFieldId} list={fieldList} onChange={this.handleChange} />
                    <span style={{ margin: '0 10px' }}>=</span>
                    <Select
                        value={investigationMedicineType}
                        placeholder="请选择"
                        style={{ width: 240 }}
                        onChange={(value) => this.handleChange(value, 'investigationMedicineType')}
                    >
                        {medicineTypeOption}
                    </Select>
                </div>
            </div>
        );
    }
}

export default InvestigationMedicineType;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/InvestigationMedicineType.js